export default function KhanAcademyIcon(props: React.ComponentProps<'svg'>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="276"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 276"
      {...props}
    >
      <path
        fill="#14BF96"
        d="M16.252 57.155A35.066 35.066 0 000 84.735v106.38a35.066 35.066 0 0016.252 27.58l95.447 53.387a36.937 36.937 0 0032.505 0l95.545-53.387a35.066 35.066 0 0016.252-27.58V84.735a35.066 35.066 0 00-16.252-27.58L144.302 3.768a36.938 36.938 0 00-32.505 0L16.252 57.155z"
      />
      <path
        fill="#FFF"
        d="M226.057 111.527c-52.993 0-92.59 43.93-92.59 97.81v2.266H122.83v-2.266c0-53.88-39.4-97.613-92.788-97.81v9.85c-.214 40.761 24.922 77.365 63.041 91.802a103.13 103.13 0 0035.362 6.304 104.804 104.804 0 0035.657-6.304c38.063-14.493 63.144-51.075 62.943-91.802-.494-3.152-.691-6.501-.987-9.85z"
      />
      <circle cx="128.05" cy="86.114" r="29.55" fill="#FFF" />
    </svg>
  )
}
